import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AddPost } from "../api/postapi";
import { ToastChange } from "../reducers/config";

type WritePost = [(body: any, isBack: boolean) => Promise<boolean>];

const UseWritePost = (succ_msg: string): WritePost => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const WritePost = useCallback(
    (body: any, isBack: boolean) => {
      return AddPost(body)
        .then(({ state, msg }) => {
          dispatch(
            ToastChange({ active: true, content: state ? succ_msg : msg })
          );
          if (isBack) {
            navigate(-1);
          }
          return state;
        })
        .catch(() => {
          return false;
        });
    },
    [navigate, succ_msg, dispatch]
  );

  return [WritePost];
};

export default UseWritePost;
